import { render, staticRenderFns } from "./MemberLabelTablePane.vue?vue&type=template&id=2d52f2fe&scoped=true"
import script from "./MemberLabelTablePane.vue?vue&type=script&lang=js"
export * from "./MemberLabelTablePane.vue?vue&type=script&lang=js"
import style0 from "./MemberLabelTablePane.vue?vue&type=style&index=0&id=2d52f2fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52f2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d52f2fe')) {
      api.createRecord('2d52f2fe', component.options)
    } else {
      api.reload('2d52f2fe', component.options)
    }
    module.hot.accept("./MemberLabelTablePane.vue?vue&type=template&id=2d52f2fe&scoped=true", function () {
      api.rerender('2d52f2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/member_label/MemberLabelTablePane.vue"
export default component.exports